import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class GuidesService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('guides/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('guides/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('guides/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('guides/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('guides/save', data);
  }

  
  updateSave(data: any) {
    return this.restService.save('guides/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('guides/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('guides/delete', val_id);
  }
}
